// extracted by mini-css-extract-plugin
export var tosLink = "_ak-0";